// extracted by mini-css-extract-plugin
export default {"primary":"primaryNav_primary__OfUAA"};